/*
 * Performance Observer
 * Hard-coded config: list your observers here
 */
const performanceObservers = [
	{
		containerSelector: "#vector",
		targetSelector: "#vframe",
		gtmEventName: "vector_loading_time",
	},
	// add more observers as needed:
	// {
	//   containerSelector: '#otherContainer',
	//   targetSelector:    '.otherItem',
	//   gtmEventName:      'other_event',
	// },
];

/**
 * Send a timing hit to GTM via gtag()
 */
function sendPerformanceEventToGTM(trackedElement, observer, eventName) {
	const timeToLoad = Math.round(performance.now());
	if (timeToLoad && typeof gtag === "function") {
		gtag("event", eventName, {
			event_category: "PerformanceObserver",
			event_label: trackedElement,
			value: timeToLoad,
		});
	}
	observer.disconnect();
}

/**
 * Core logic: watch additions under `container`, fire when matching `selector` appears.
 */
function measurePerformance(containerSelector, targetSelector, eventName) {
	const container = document.querySelector(containerSelector);
	if (!container || !eventName) return;

	const termType = targetSelector[0]; // "#" or "."
	const term = targetSelector.slice(1);

	const observer = new MutationObserver((mutations) => {
		for (const { addedNodes } of mutations) {
			for (const node of addedNodes) {
				let found = false;

				// direct match on the node
				if (termType === "#" && node.id === term) found = true;
				if (termType === "." && node.classList?.contains(term))
					found = true;

				// fallback: any child matches?
				if (!found) {
					for (const child of node.childNodes) {
						if (
							(termType === "#" && child.id === term) ||
							(termType === "." &&
								child.classList?.contains(term))
						) {
							found = true;
							break;
						}
					}
				}

				if (found) {
					sendPerformanceEventToGTM(
						targetSelector,
						observer,
						eventName,
					);
					return; // stop after first hit
				}
			}
		}
	});

	observer.observe(container, {
		childList: true,
		attributes: false,
		characterData: false,
	});
}

// Kick off all observers:
for (const obs of performanceObservers) {
	measurePerformance(
		obs.containerSelector,
		obs.targetSelector,
		obs.gtmEventName,
	);
}
